import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { PortfolioApiService } from './portfolio.service';
import {
  loadPortfolioList,
  loadPortfolioListSuccess,
  loadPortfolioListFailure,
} from './portfolio.actions';

@Injectable()
export class PortfolioEffects {
  private actions$ = inject(Actions);
  private portfolioService = inject(PortfolioApiService);

  loadPortfolioList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPortfolioList),
      mergeMap(() =>
        this.portfolioService.getPortfolioList().pipe(
          map((response: any) => {
            if (response.status === 'Failed') {
              return loadPortfolioListFailure({ error: response.message });
            }
            return loadPortfolioListSuccess({ data: response.data });
          }),
          catchError((error) => of(loadPortfolioListFailure({ error })))
        )
      )
    )
  );
}
